import { Utils } from 'formiojs';
import { form as template } from 'src/formio/templates/base/form';

const compiledForm = Utils.Evaluator.template(template, 'component');
export const formioBaseComponentCustomTemplate = (ctx: any) => {
    return compiledForm(ctx);
};
